import styled from 'styled-components';
import { Subtitle } from 'components/Typography';
import { FiChevronDown, FiChevronUp, FiAlignJustify } from 'react-icons/fi';
import AddButton from 'components/Buttons/AddButton';
import addAlpha from 'utils/addAlpha';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  width: 100%;
  height: auto;
  border-radius: 1.5rem;
  background: ${({ theme }) => theme.colors.white};
  margin-bottom: 1.5rem;
  padding: 0.25rem;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  height: 4.5rem;
  padding: 0 2rem;
`;

// TODO: TFR-44 move to icon group
export const DraggableIcon = styled(FiAlignJustify)`
  display: none;
  position: absolute;
  left: -2.125rem;
  width: 1.25rem;
  height: 1.25rem;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

// TODO: TFR-45:Header make unique name or do not export
export const Header = styled(Row)`
  position: relative;
  justify-content: space-between;
  border-radius: 1.25rem;

  :hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.gray1};

    ${DraggableIcon} {
      display: initial;
    }
  }
`;

// TODO: TFR-44 move to typography group
export const NameCategory = styled(Subtitle)`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.navyGreen};
`;

// TODO: TFR-44 move to icon group
export const ArrowDown = styled(FiChevronDown)`
  width: 1.5rem;
  height: 1.5rem;
`;

// TODO: TFR-44 move to icon group
export const ArrowUp = styled(FiChevronUp)`
  width: 1.5rem;
  height: 1.5rem;
`;

// TODO: TFR-44 move to container group
export const Content = styled.div``;

// TODO: TFR-44 move to container group
export const Footer = styled(Row)``;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(AddButton)`
  margin-right: 2rem;
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
